import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from "react-router";
import PricingCard from '../components/PricingCard';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import * as theme from '../theme';

export default function Home() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (currentUser) {
      navigate('/dashboard');
    }
  }, [currentUser]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        padding: 4,
      }}
    >
        <PricingCard />
        <Typography
          variant="body1"
          sx={{
            fontSize: 16,
            textAlign: 'center',
            letterSpacing: 1.6,
            maxWidth: 338,
            marginTop: 2,
            marginBottom: 2
          }}
        >
          Introductory offer valid for next 4 enrollments.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate('/enroll')}
          sx={{ width: 200, marginBottom: 6 }}
        >
          Enroll Now
        </Button>
         <Typography
          variant="body1"
          sx={{
            fontSize: 16,
            textAlign: 'center',
            letterSpacing: 1.6,
            maxWidth: 338,
          }}
        >
          Already Enrolled?
        </Typography>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => navigate('/sign-in')}
          sx={{ width: 200 }}
        >
          Sign In
        </Button>
    </Box>
  );
}